import { Component, OnInit } from '@angular/core';
import { InvoiceService } from 'app/shared/services/invoice.service';
import { BsDatepickerConfig} from 'ngx-bootstrap/datepicker';
import { CustomerService} from 'app/shared/services/customer.service';
import { HttpErrorResponse } from '@angular/common/http';
import { Router} from '@angular/router';
import * as moment from 'moment';
import * as XLSX from 'xlsx'; 
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
pdfMake.vfs = pdfFonts.pdfMake.vfs;
import { DecimalPipe } from '@angular/common';
import { NbThemeService } from '@nebular/theme';
import {FormControl} from '@angular/forms';
import {Observable} from 'rxjs';
import {map, startWith} from 'rxjs/operators';
import { VehicleRegisterService } from 'app/shared/services/vehicle-register.service';


@Component({
  selector: 'app-sales-report',
  templateUrl: './sales-report.component.html',
  styleUrls: ['./sales-report.component.css']
})
export class SalesReportComponent implements OnInit {

  datepickerConfig : Partial<BsDatepickerConfig>

  fromDate : Date;
  toDate : Date;
  cusName : string;
  vehicle : string = null;
  vehicleType : string =null;
  isDark: boolean = false;

  myControl = new FormControl();
  filteredCustomerList: Observable<any[]>;
  customerList : any[];

  vehicleList:any;


  VEHICLE_TYPE= [
    {value: 'Owned'},
    {value: 'Rented'},
  ];


  invoiceLst : any[]=[];
  filteredInvoiceList : any[]=[];


  constructor(
              private invoiceService : InvoiceService, 
              private vehicleRegisterService :VehicleRegisterService,
              private router : Router, 
              private themeService: NbThemeService,
              private customerService : CustomerService,
              private decimalPipe: DecimalPipe
             )
              {
                this.datepickerConfig = Object.assign({},
                {   
                  showWeekNumbers:false,
                  dateInputFormat : 'YYYY-MM-DD'
                });

              }

    ngOnInit() {
      this.getAllInvoices();  
      this.getCustomerList();
      this.autoCompleteCustomer();
      this.getVehicleList();

      this.themeService.onThemeChange()
      .subscribe(themeName =>{
           this.isDark  = themeName.name ==='dark' ? true : false;
         });
    }


    getVehicleList(){
      this.vehicleRegisterService.getAll()
       .subscribe(
          (data) => {
                    this.vehicleList = data; 
                    },
         (err) => 
                  {
                    if(err instanceof HttpErrorResponse){                 
                      if(err.status == 401){
                        this.router.navigate(['/login']);
                      }
                    }
                    console.log(err);
                   });  
         
       }

    autoCompleteCustomer(){
      this.filteredCustomerList = this.myControl.valueChanges
      .pipe(
        startWith(''),
        map(value => this._filterCustomer(value))
      ); 
  }

  private _filterCustomer(cusName: string): any[] {
    if(cusName){
       const filterValue = cusName.toLowerCase();
       return this.customerList.filter(option => option.CusName.toLowerCase().indexOf(filterValue) === 0);
    }
  }


 
    getAllInvoices(){
    this.invoiceService.getAll()
     .subscribe(
        (data) => {
                  this.invoiceLst = data;  
                 // this.filteredInvoiceList =  this.invoiceLst ;                           
                  },
       (err) => 
                {
                  if(err instanceof HttpErrorResponse){                 
                    if(err.status == 401){
                      this.router.navigate(['/login']);
                    }
                  }
                  console.log(err);
                });          
     }

     getCustomerList(){
      this.customerService.getAll()
       .subscribe(
          (data) => {
                    this.customerList = data.filter((el)=>{
                      return el.Status !=="Deactivated";
                    });             
                    },
         (err) => 
                  {
                    if(err instanceof HttpErrorResponse){                 
                      if(err.status == 401){
                        this.router.navigate(['/login']);
                      }
                    }
                    console.log(err);
                  });  
         
       }
    

     getTotalSales(){
      return this.filteredInvoiceList.map(data=>data.GrandTotal).reduce((acc,value)=>acc + +value,0);
    }
    

     viewBtnClicked(){
      var startDate =moment(this.fromDate).format("YYYY-MM-DD");
      var endDate =moment(this.toDate).format("YYYY-MM-DD");

      if(this.fromDate && this.toDate  && this.vehicle && this.vehicleType && this.cusName){
        this.filteredInvoiceList = this.invoiceLst.filter(data => {
          var expDate = moment(data.InvoiceDate).format("YYYY-MM-DD");              
           return moment(expDate).isBetween(startDate, endDate,undefined,'[]') 
           && data.Vehicle.toLowerCase().trim()===this.vehicle.trim().toLowerCase()
           && data.VehicleType.toLowerCase().trim()===this.vehicleType.trim().toLowerCase()
           && data.CusName.toLowerCase().trim()===this.cusName.trim().toLowerCase();
           });

      }

      else if(this.fromDate && this.toDate  && this.vehicle  && this.cusName){
        this.filteredInvoiceList = this.invoiceLst.filter(data => {
          var expDate = moment(data.InvoiceDate).format("YYYY-MM-DD");              
           return moment(expDate).isBetween(startDate, endDate,undefined,'[]') 
           && data.Vehicle.toLowerCase().trim()===this.vehicle.trim().toLowerCase()
           && data.CusName.toLowerCase().trim()===this.cusName.trim().toLowerCase();
           });

      }

     else if(this.fromDate && this.toDate  && this.vehicleType && this.cusName){
        this.filteredInvoiceList = this.invoiceLst.filter(data => {
          var expDate = moment(data.InvoiceDate).format("YYYY-MM-DD");              
           return moment(expDate).isBetween(startDate, endDate,undefined,'[]') 
           && data.VehicleType.toLowerCase().trim()===this.vehicleType.trim().toLowerCase()
           && data.CusName.toLowerCase().trim()===this.cusName.trim().toLowerCase();
           });

      }

      else if(this.fromDate && this.toDate  && this.vehicle && this.vehicleType){
        this.filteredInvoiceList = this.invoiceLst.filter(data => {
          var expDate = moment(data.InvoiceDate).format("YYYY-MM-DD");              
           return moment(expDate).isBetween(startDate, endDate,undefined,'[]') 
           && data.Vehicle.toLowerCase().trim()===this.vehicle.trim().toLowerCase()
           && data.VehicleType.toLowerCase().trim()===this.vehicleType.trim().toLowerCase();
           });

      }

      else if(this.fromDate && this.toDate  && this.vehicle){
        this.filteredInvoiceList = this.invoiceLst.filter(data => {
          var expDate = moment(data.InvoiceDate).format("YYYY-MM-DD");              
           return moment(expDate).isBetween(startDate, endDate,undefined,'[]') 
           && data.Vehicle.toLowerCase().trim()===this.vehicle.trim().toLowerCase();
           });

      }

      else if(this.fromDate && this.toDate  && this.vehicleType){
        this.filteredInvoiceList = this.invoiceLst.filter(data => {
          var expDate = moment(data.InvoiceDate).format("YYYY-MM-DD");              
           return moment(expDate).isBetween(startDate, endDate,undefined,'[]') 
           && data.VehicleType.toLowerCase().trim()===this.vehicleType.trim().toLowerCase();
           });

      }

      else if(this.fromDate && this.toDate  && this.cusName){
        this.filteredInvoiceList = this.invoiceLst.filter(data => {
          var expDate = moment(data.InvoiceDate).format("YYYY-MM-DD");              
           return moment(expDate).isBetween(startDate, endDate,undefined,'[]') 
           && data.CusName.toLowerCase().trim()===this.cusName.trim().toLowerCase();
           });

      }

      else if(this.fromDate && this.toDate){
        this.filteredInvoiceList = this.invoiceLst.filter(data => {
          var expDate = moment(data.InvoiceDate).format("YYYY-MM-DD");              
           return moment(expDate).isBetween(startDate, endDate,undefined,'[]'); 
           });

      }
        
        
    }


     clearBtnClicked(){
      this.fromDate = null;
      this.toDate = null;
      this.vehicle= null;
      this.vehicleType= null;
      this.cusName= '';
      this.filteredInvoiceList =  [];
     }

     savePDF(action){

      const documentDefinition = { 
        pageSize: 'A4',
        pageOrientation: 'portrait',

        content: [   
          { text: 'Sales Report', style: 'reportHeader' }, 
          { text: (this.fromDate && this.toDate) ? `${moment(this.fromDate).format("YYYY-MM-DD")} To ${moment(this.toDate).format("YYYY-MM-DD")}` : '',alignment: 'center',margin: [0, 3] }, 
          { text: this.vehicle ? `Vehicle : ${this.vehicle}` : '',alignment: 'center',margin: [0, 3] }, 
          { text: this.vehicleType ? `Vehicle Type : ${this.vehicleType}` : '',alignment: 'center',margin: [0, 3] }, 
          { text: this.cusName ? `Customer : ${this.cusName}` : '',alignment: 'center',margin: [0, 3] }, 
           
           `\n`,         
          {  
            table: {  
                headerRows: 1,  
                widths: ['auto', 'auto', '*', 'auto', 'auto', 'auto'],  
                body: [  
                  ['InvoiceDate','InvoiceNo', 'Customer','Vehicle', 'VehicleType', 'Amount'],
                  ...this.filteredInvoiceList.map(p => ([moment(p.InvoiceDate).format("YYYY-MM-DD"), p.InvoiceNo, p.CusName, { text : p.Vehicle }, { text : p.VehicleType }, { text: this.transformNumberFormat(p.GrandTotal),alignment: 'right' }])),  
                  [ { text: 'Total Sales', bold: true, colSpan: 5 }, {},{},{},{}, { text :  this.transformNumberFormat(this.getTotalSales()),alignment: 'right', bold : true } ]  
                ]           
          }
        }
        ],
        styles: {  
          reportHeader: {  
              bold: true,  
              decoration: 'underline',  
              fontSize: 14,  
              margin: [0, 15, 0, 10],
              alignment: 'center',             
          }  
        }  
       };

        if(action==='open'){    
              pdfMake.createPdf(documentDefinition).open();  
          }else if(action === 'print'){    
              pdfMake.createPdf(documentDefinition).print();          
          }
     }

     exportexcel(): void 
     {
        /* table id is passed over here */   
        let element = document.getElementById('salesReport'); 
        const ws: XLSX.WorkSheet =XLSX.utils.table_to_sheet(element);
 
        /* generate workbook and add the worksheet */
        const wb: XLSX.WorkBook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
 
        /* save to file */
        XLSX.writeFile(wb, 'Sales Report.xlsx');
       
     }

     transformNumberFormat(number) {
      return this.decimalPipe.transform(number,'1.2-2');
     }

}
